/* eslint-disable */
import { Node, Plugin } from 'tiptap'

export default class Image extends Node {

  get name() {
    return 'audio'
  }

  get schema() {
    return {
      inline: true,
      atom: true,
      attrs: {
        src: {},
        controls: {
          default: true,
        },
        autoplay: {
          default: null,
        },
        title: {
          default: null,
        },
      },
      group: 'inline',
      draggable: true,
      parseDOM: [
        {
          tag: 'audio[src]',
          getAttrs: dom => ({
            src: dom.getAttribute('src'),
            controls: dom.getAttribute('controls'),
            autoplay: dom.getAttribute('autoplay'),
            title: dom.getAttribute('title'),
          }),
        },
      ],
      toDOM: node => ['audio', node.attrs],
    }
  }

  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }
}


// WEBPACK FOOTER //
// ./src/others/audio.js